const typography = dir => ({
  useNextVariants: true,
  fontFamily: dir === 'rtl' ? ['madani', 'sans-serif'].join(',') : ['Gilroy', 'sans-serif'].join(','),
  title: {
    fontWeight: 700,
  },
  body2: {
    fontWeight: 400,
  },
  fontWeightMedium: 700,
});

export default typography;
